/** @format */

import React, { useState, useEffect } from 'react'
import { _$, Button, Icon, Tooltip, Dialog, Message } from 'kpc-react'
import styled from 'styled-components'
import { MonitorSearch, TablePage, Divider } from 'src/components'
import API from 'src/api/ApiContacts'
import { TableItemProps } from 'src/containers/MonitorContacts/constants'
import useFormTable from 'src/hooks/useFormTable'
import ContactsDrawer from 'src/containers/MonitorContacts/ContactsDrawer'
import { request } from 'src/utils'

const Contacts: React.FC<{ className?: string }> = ({ className }) => {
  const [query, setQuery] = useState<string>('')
  const [tableData, setTableData] = useState<any[]>([])
  const [checkedUser, setCheckedUser] = useState<number[]>([])
  const [drawerVisible, setDrawerVisible] = useState<boolean>(false)
  const [curUser, setCurUser] = useState<TableItemProps>({})
  const [tableGroup, setTableGroup] = useState<{ status: number }>({ status: 0 })
  const [statusBtnDisabeld, setStatusBtnDisabled] = useState<boolean | number>(false)

  // useFormTable
  const { run, total, pageState, loading } = useFormTable(
    API.getAlertUser,
    {
      params: {
        Query: query,
        Cap: 1,
        Enabled: tableGroup.status || ''
      },
      manual: true
    },
    data => {
      setTableData(data?.userlist || [])
      return {
        tableData: data?.userlist,
        totalCount: data?.totalcount
      }
    }
  )

  // 判断禁用/启动按钮状态
  useEffect(() => {
    if (checkedUser?.length) {
      const status = checkedUser.map(userId => {
        const find = tableData.find(({ userid }) => userId === userid)
        return find ? find.status : false
      })
      const every = status.every(item => status[0] === item)
      setStatusBtnDisabled(every ? status[0] : !every)
    } else {
      setStatusBtnDisabled(true)
    }
  }, [checkedUser])

  // 删除联系人
  const deleteUser = async (userIds = checkedUser) => {
    if (userIds?.length) {
      const result = await request(API.delAlertUse, {
        method: 'POST',
        data: {
          UserIdList: userIds
        }
      })
      if (result.code === 'Success') {
        run({
          Query: query,
          Enabled: tableGroup.status || ''
        })
        setCheckedUser([])
        Message.success(result?.['message'])
      }
    }
  }

  // 修改联系人状态
  const updateUserStatus = async (userId = checkedUser, status) => {
    if (userId?.length && status) {
      const result = await request(API.updateAlertUseStatus, {
        method: 'PUT',
        data: {
          userId,
          status
        }
      })
      if (result.code === 'Success') {
        run({
          Query: query
        })
        setCheckedUser([])
        Message.success(result?.['message'])
      }
    }
  }

  // table scheme
  const tableScheme = {
    name: {
      title: _$('姓名'),
      minWidth: 100,
      template({ name }) {
        return <p className="text-overflow">{name}</p>
      }
    },
    status: {
      title: _$('状态'),
      minwidth: 80,
      group: [
        { label: _$('全部'), value: 0 },
        { label: _$('启用'), value: 1 },
        { label: _$('禁用'), value: 2 }
      ],
      template({ status }) {
        return <>{status === 1 ? _$('启用') : _$('禁用')}</>
      }
    },
    phone: {
      title: _$('电话'),
      minWidth: 120
    },
    email: {
      title: _$('邮箱'),
      minWidth: 200,
      template({ email }) {
        return <p className="text-overflow">{email}</p>
      }
    },
    usergroup: {
      title: _$('所属组'),
      minWidth: 200,
      template({ usergroup }) {
        return (
          <div className="ksc-space">
            {usergroup?.length &&
              usergroup.map(({ name, usrgrpid }) => <span key={usrgrpid}>{name}</span>)}
          </div>
        )
      }
    },
    active: {
      title: _$('操作'),
      minWidth: 120,
      template(item) {
        const { userid, status, name } = item
        return (
          <div className="ksc-space">
            <a
              className="primary-color"
              onClick={() => {
                setDrawerVisible(true)
                setCurUser({
                  ...item
                })
              }}
            >
              {_$('修改')}
            </a>
            <Divider />
            <Tooltip
              content={_$('确定删除？', { name })}
              confirm
              theme="light"
              trigger="click"
              onOk={() => {
                deleteUser([userid])
              }}
            >
              <a className="primary-color">{_$('删除')}</a>
            </Tooltip>
            <Divider />
            <Tooltip
              content={status === 1 ? _$('确认禁用所选联系人吗？') : _$('确认启用所选联系人吗？')}
              confirm
              theme="light"
              trigger="click"
              onOk={() => {
                updateUserStatus([userid], status === 1 ? 2 : 1)
              }}
            >
              <a className="primary-color">{status === 1 ? _$('禁用') : _$('启用')}</a>
            </Tooltip>
          </div>
        )
      }
    }
  }

  // filter table
  useEffect(() => {
    run({
      Query: query,
      Enabled: tableGroup.status || '',
      PageIndex: 1
    })
  }, [tableGroup.status])

  return (
    <div className={className}>
      <div className="header">
        <div className="button">
          <Button
            type="primary"
            onClick={() => {
              setCurUser({})
              setDrawerVisible(true)
            }}
          >
            <Icon className="ion-person-add"></Icon>
            {_$('新建联系人')}
          </Button>
          <Button
            disabled={statusBtnDisabeld === true ? statusBtnDisabeld : statusBtnDisabeld === 1}
            onClick={() => {
              Dialog.confirm({
                content: _$('确认启用所选联系人吗？')
              }).then(() => {
                updateUserStatus(undefined, 1)
              })
            }}
          >
            {_$('启用')}
          </Button>
          <Button
            disabled={statusBtnDisabeld === true ? statusBtnDisabeld : statusBtnDisabeld === 2}
            onClick={() => {
              Dialog.confirm({
                content: _$('确认禁用所选联系人吗？')
              }).then(() => {
                updateUserStatus(undefined, 2)
              })
            }}
          >
            {_$('禁用')}
          </Button>
          <Button
            disabled={!checkedUser.length}
            onClick={() => {
              Dialog.confirm({
                content: _$('确认删除所选联系人吗？')
              }).then(() => {
                deleteUser()
              })
            }}
          >
            {_$('删除')}
          </Button>
        </div>
        <MonitorSearch
          placeholder={_$('搜索关键词')}
          value={query}
          onChange={value => {
            setQuery(value)
            run({
              Query: value,
              Enabled: tableGroup.status || '',
              PageIndex: 1
            })
          }}
        />
      </div>
      <div className="table marginTop">
        <TablePage
          tableProps={{
            scheme: tableScheme,
            data: tableData,
            resizable: true,
            checkedKeys: checkedUser,
            rowCheckable: false,
            rowKey: item => item.userid,
            'on$change-checked': (_c, value) => {
              setCheckedUser(value)
            },
            group: tableGroup,
            'on$change-group': (_c, value) => {
              setTableGroup({
                status: value.status
              })
            }
          }}
          pageProps={{ total, ...pageState }}
          loading={loading}
          run={run}
        />
      </div>
      <ContactsDrawer
        visible={drawerVisible}
        closeDrawer={(update = false) => {
          setCurUser({})
          setDrawerVisible(false)
          update &&
            run({
              Query: query,
              Enabled: tableGroup.status || '',
              PageIndex: 1
            })
        }}
        curUser={curUser}
      />
    </div>
  )
}
export default styled(Contacts)`
  .header {
    display: flex;
    justify-content: space-between;
    .button {
      display: flex;
      & > * {
        margin-right: 8px;
      }
    }
  }
  .table p {
    margin-bottom: 0;
  }
`
